module.exports = __webpack_public_path__ + "img/hero-section-top-bg.b13352f7.png";